<app-compliance-nav [activeMenuItem]="'riskCheck'"></app-compliance-nav>
<mat-card class="content-card">

  <app-mat-table-generator #table
    tableName="riskCheckTable"
    [useEmbededFilter]="false"
    [columns]="columns"
    [dataSource]="dataSource"
    [editEnabled]="false"
    [viewLink]="getViewLink"
    [deleteEnabled]="currentUserIsAdmin()"
    [multiselectEnabled]="false"
    >
  </app-mat-table-generator>
</mat-card>
